export default __webpack_public_path__ + "static/media/fw-mia-er-Yellow Gold.7de575de.mp4";